/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface GameTrackerPublicControllerDeleteGamePbp$Params {
  userUuid: string;
  localId: string;
  accessHash: string;
  pbpUuid: string;
}

export function gameTrackerPublicControllerDeleteGamePbp(http: HttpClient, rootUrl: string, params: GameTrackerPublicControllerDeleteGamePbp$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, gameTrackerPublicControllerDeleteGamePbp.PATH, 'delete');
  if (params) {
    rb.path('userUuid', params.userUuid, {});
    rb.path('localId', params.localId, {});
    rb.path('accessHash', params.accessHash, {});
    rb.path('pbpUuid', params.pbpUuid, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

gameTrackerPublicControllerDeleteGamePbp.PATH = '/game-tracker-public/user/{userUuid}/games/{localId}/{accessHash}/pbp/{pbpUuid}';
